import React from 'react';
import '../styles/Legal.css';

const LegalTerms = () => {
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>

      <h2>Acceptance</h2>
      <p>By using TheBoxEsports, you agree to these Terms.</p>

      <h2>Eligibility</h2>
      <p>You must be at least 16 years old (or older if required in your region).</p>

      <h2>Accounts</h2>
      <p>You’re responsible for your login, activity, and keeping info accurate.</p>

      <h2>Acceptable Use</h2>
      <p>Don’t break the law, abuse the service, scrape, reverse engineer, or disrupt other users.</p>

      <h2>Intellectual Property</h2>
      <p>
        We own the service and content we provide. You retain rights to content you upload; you grant us a
        license to host and display it to operate the service.
      </p>

      <h2>Subscriptions &amp; Trials</h2>
      <ul>
        <li>Plans may include free trials. Trials convert to paid unless canceled before the trial ends.</li>
        <li>Billing is in the currency shown at checkout. Prices may change with notice; changes apply to future periods.</li>
        <li>If payment fails, access may be paused until resolved.</li>
      </ul>

      <h2>Cancellations</h2>
      <p>You can cancel anytime; access continues through the current paid period. No refunds for partial periods unless required by law.</p>

      <h2>Termination</h2>
      <p>We may suspend/terminate for violations or misuse. You may stop using the service at any time.</p>

      <h2>Disclaimers &amp; Liability</h2>
      <p>
        Service is “as is.” To the fullest extent permitted, we’re not liable for lost data, profits, or indirect damages.
        Our total liability is limited to the amount you paid in the past 3 months.
      </p>

      <h2>Startup/Partnership Note</h2>
      <p>TheBoxEsports is an evolving startup; features may change and we’re iterating. We value clear communication and collaboration to improve the system.</p>

      <h2>Changes</h2>
      <p>We may update these Terms; continued use means acceptance of changes.</p>

      <h2>Contact</h2>
      <p>cali.salcedo@theboxesports.com (Founder, TheBoxEsports)</p>
    </div>
  );
};

export default LegalTerms;
